import { useEffect, useCallback, useState, useRef } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Menu from "../../../components/Menu";
import Loading from "../../../components/Loading";

import api from "../../../services/api";

const initialState = {
    eficiencia: "",
    premio: "",
    tipo: "2"
}

export default function PremioEficiencia() {
    const [data, setData] = useState();
    const [form, setForm] = useState({...initialState});

    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get("cadastros/premio-eficiencia").then((response) => {
            setData(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            showError(error);
        });
    }, []);

    const handleSubmit = () => {
        setIsLoading(true);
        api.post("cadastros/premio-eficiencia", form).then((response) => {
            fetchData();
            setIsLoading(false);
            showSuccess(response);
        }).catch((error) => {
            setIsLoading(false);
            showError(error);
        }); 
    }

    const handleDelete = (rowData) => {
        confirmDialog({
            acceptClassName: "p-button-danger",
            acceptLabel: "Excluir",
            rejectClassName: "p-button-secondary",
            rejectLabel: "Cancelar",
            header: "Excluir",
            message: "Você tem certeza que deseja excluir esse registro? Eficiência " + rowData.eficiencia,
            accept: () => {
                setIsLoading(true);
                api.delete(`cadastros/premio-eficiencia/${rowData.id}/delete`).then((response) => {
                    fetchData();
                    setIsLoading(false);
                    showSuccess(response)
                }).catch((error) => {
                    setIsLoading(false);
                    showError(error);
                });
            }
        });
    }

    const onHide = () => {
        setIsVisible(false);
    }

    const onShow = () => {
        setIsVisible(true);
    }

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    if(isLoading) {
        return <Loading />
    }

    return (
        <div>
            <Toast ref={toast} />
            <Menu />

            <Dialog
                header="Cadastrar"
                onHide={onHide}
                style={{ minWidth: "40vw" }}
                visible={isVisible}
            >
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="eficiencia">Eficiência</label>
                        <InputText 
                            onChange={e => setForm({...form, eficiencia: e.target.value })}
                            placeholder="Exemplo: 95(%)"
                            value={form.eficiencia}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="premio">Prêmio</label>
                        <InputText 
                            onChange={e => setForm({...form, premio: e.target.value })}
                            placeholder="Exemplo: 20(%)"
                            value={form.premio}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="tipo">Tipo: </label>
                        <Dropdown
                            onChange={e => setForm({...form, tipo: e.value })}
                            options={[
                                { label: 'Turma', value: '2' },
                                { label: 'Grupo', value: '3' }
                            ]}
                            value={form.tipo}
                        />
                    </div>
                    <div className="p-d-flex p-flex-row">
                        <Button className="p-button-secondary p-mr-2" label="Cancelar" onClick={onHide} />
                        <Button className="p-button-success p-ml-2" label="Salvar" onClick={handleSubmit} />
                    </div>
                </div>
            </Dialog>

            <Card
                className="p-m-1"
                title="Cadastro de Prêmio por Eficiência"
            >
                <div className="p-d-flex p-flex-row p-jc-end">
                    <Button 
                        className="p-m-1"
                        icon="pi pi-plus"
                        onClick={onShow}
                        title="Clique para CRIAR um novo registro"
                    />
                </div>
                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    groupRowsBy="tipo"
                    responsiveLayout="scroll"
                    rowGroupMode="subheader"
                    rowGroupHeaderTemplate={(data) => (
                        <h3 className="p-m-1">{data.tipo === "2" ? "Turma" : "Grupo"}</h3>
                    )}
                    rowHover
                    size="small"
                    value={data}
                >
                    <Column header="ID" field="id" sortable />
                    <Column header="Eficiência" field="eficiencia" sortable />
                    <Column header="Prêmio" field="premio" sortable />
                    <Column header="Excluir" body={(rowData) => (
                        <Button 
                            className="p-button-danger"
                            icon="pi pi-trash"
                            onClick={() => handleDelete(rowData)}
                            title="Clique para EXCLUIR o registro"
                        />
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}